import { useEffect, useState } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useTickets = ({
  searchParam,
  tags,
  users,
  pageNumber,
  status,
  date,
  updatedAt,
  showAll,
  queueIds,
  withUnreadMessages,
  searchOnMessages,
  sortAscending, // ✅ AGREGADO: Para ordenamiento
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    // ✅ CORREGIDO: Siempre ejecutar para cargar tickets
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        try {
          // ✅ NO CONVERTIR STATUS "ai" - Enviar directamente al backend
          const backendStatus = status;
          
          const { data } = await api.get("/tickets", {
            params: {
              searchParam,
              pageNumber,
              tags,
              users,
              status: backendStatus,
              date,
              updatedAt,
              showAll: showAll ? "true" : "false", // ✅ CORREGIDO: Convertir boolean a string
              queueIds,
              withUnreadMessages,
              searchOnMessages,
              sortAscending, // ✅ AGREGADO: Parámetro de ordenamiento
            },
          });
          setTickets(data.tickets);
          setHasMore(data.hasMore);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchTickets();
    }, 300); // ✅ AUMENTADO A 300ms para evitar spam
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    tags,
    users,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
    searchOnMessages,
    sortAscending, // ✅ AGREGADO: Dependencia para ordenamiento
  ]);

  return { tickets, loading, hasMore };
};

export default useTickets;
